// extracted by mini-css-extract-plugin
export default {"main":"main_main__8k8Ga","temporaryMenu":"main_temporaryMenu__SnouP"};